export enum GlobalErrorType {
  InactiveUser = 'inactiveUser',
  PaymentRequired = 'paymentRequired',
}
